import React from 'react';
import $, { error } from 'jquery';
import OrderService from '../services/order';
import ShippingService from '../services/shipping';
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
import printJS from 'print-js';
import Utility from '../utilities/utility';
import placeholder from '../placeholder.png';
import ProductImagesModal from './productImagesModal';
import ProductService from '../services/product';

class OrderProduct extends React.Component {

    constructor(props) {
        super(props);

        this.shippingService = new ShippingService();
        this.selectedShipment = localStorage.getItem('selectedShipment');
        this.productService = new ProductService();

        this.state = {

            showModal: false,
            showTransferModal: false,
            submitted : false,
            shipmentSubmitted: false,
            pickingSubmitted: false,
            showGalleryModal: false,
            galleryImages: [],
            galleryLoading: false,
            galleryProduct: null

        };

    }


     addProduct = async(productId, orderId, id) =>{

        try {
            let quantity = $('#order-product-quantity-' + id).val();

            if (Utility.isEmpty(quantity) || this.state.submitted == true) {

                return;
            }

            let response = await OrderService.addToOrder(orderId, quantity, productId);

            if(response.ok){

                let data = await response.json();

                $('#prd-quantity-' + id).html(data.quantity);

            }
            

        } catch (error) {

            this.setState({ submitted : false});

        }

    }



    updatePrice = async (id) => {

        try {

            let price = $('#order-product-price-' + id).val();

            let response = await OrderService.updateOrderProductPrice(id, price);



            let responseData = await response.json();


            let orderProduct = responseData.orderProduct;


            this.setState({ order: responseData.order });

            console.log(this.state.order);



            $('#prd-price-' + id).html(orderProduct.price);

        } catch (error) {

        }

    }

    addToShipment = (orderProductId, productQty) => {

        let quantity = $('#shipment-product-quantity-' + orderProductId).val();
        
        if (quantity == 0) {

            $('#order-product-row-' + orderProductId).before(
                '<div class="alert alert-danger order-product-row">La quantité doit etre fourni</div>'
            );
            $('.order-product-row').delay(3000).fadeOut('slow');

            return;
        }


        if (this.state.shipmentSubmitted) {

            $('#order-product-row-' + orderProductId).before(
                '<div class="alert alert-danger order-product-row">Erreur de submission</div>'
            );
            $('.order-product-row').delay(3000).fadeOut('slow');

            return;
        }





        const response = this.shippingService.addProduct(this.selectedShipment, orderProductId, quantity);



        response.then(res => res.json())
            .then(data => {
                if (Utility.isEmpty(data)) {

                    return;
                }

                let remainingQuantity = productQty - data.quantity;


                $('#remaining-quantity-' + orderProductId).html('Reste: ' + remainingQuantity);
                $('#total-shipped-' + orderProductId).html('Chargé: ' + data.quantity);

                console.log(data);
                $('#shipment-product-quantity-' + orderProductId).val('')
                // $('#prd-quantity-' + orderProductId).html(data.quantity);
                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-success order-product-alert">Produit Ajouté</div>'
                );

                $('.order-product-alert').delay(3000).fadeOut('slow');
                
                this.setState({shipmentSubmitted: false});

            }).catch(error => {

                this.setState({shipmentSubmitted: false});

                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-danger order-product-alert">Produit non Ajouté</div>'
                );

                $('.order-product-alert').delay(3000).fadeOut('slow');
            });

    }



    updateStatus = async (id, statusId, status) => {



        const response = await OrderService.updateOrderProductStatus(id, parseInt(statusId));

        if (response.ok) {

            window.location.reload();

            /*let product = this.state.product;

            console.log(statusId);
            product.status = status;

            this.setState({

                product : product
            });


            $('.messageHolder').html(
                '<div class="alert alert-success order-product-alert">Statut mis a jour</div>'
            );
            $('.order-product-alert').delay(3000).fadeOut('slow');*/
        }


    }



    updateSuplier = async (orderProductId, supplierId) => {

        try {

            const response = await OrderService.setOrderProductSupplier(orderProductId, supplierId);

            if (response.ok) {

                $('.messageHolder').html(
                    '<div class="alert alert-success order-product-alert">Fournisseur mis a jour</div>'
                );
                $('.order-product-alert').delay(3000).fadeOut('slow');
            } else {

                $('.messageHolder').html(
                    '<div class="alert alert-danger order-product-alert">Probleme lors du mis a jour</div>'
                );
                $('.order-product-alert').delay(3000).fadeOut('slow');
            }

        } catch (error) {

            $('.messageHolder').html(
                '<div class="alert alert-danger order-product-alert">Probleme lors du mis a jour</div>'
            );
            $('.order-product-alert').delay(3000).fadeOut('slow');
        }


    }


    confirmRemoveOrderProduct = () => {

        this.setState({ showModal: true });
    }




    handleCloseModal = () => {

        this.setState({ showModal: false });
    }


    getImageUrl = (image) => {

        if (Utility.isEmpty(image)) {
            return placeholder;
        }

        if (typeof image === 'string') {
            return image;
        }

        if (!Utility.isEmpty(image.fullUrl)) {
            return image.fullUrl;
        }

        if (!Utility.isEmpty(image.url)) {
            return image.url;
        }

        if (!Utility.isEmpty(image.name)) {
            return `${process.env.REACT_APP_API_URL}/images/${image.name}`;
        }

        return placeholder;
    }

    openProductImages = async (product) => {

        this.setState({
            showGalleryModal: true,
            galleryLoading: true,
            galleryImages: [],
            galleryProduct: product
        });

        console.log('test');

        try {
            const response = await ProductService.fetchProductImages(product.productId);

            if (response.ok) {
                const images = await response.json();
                const galleryImages = images || [];

                this.setState({
                    galleryImages: galleryImages,
                    galleryLoading: false
                });
            } else {
                this.setState({
                    galleryImages: [],
                    galleryLoading: false
                });
            }

        } catch (error) {
            this.setState({
                galleryImages: [],
                galleryLoading: false
            });
        }
    }

    closeProductImages = () => {
        this.setState({
            showGalleryModal: false,
            galleryImages: [],
            galleryLoading: false,
            galleryProduct: null
        });
    }

    acknowledgeProductChanges = async (e, productId) => {

        e.preventDefault();

        const response = await OrderService.acknowledgeOrderProductChanges(productId);

        if (response.ok) {

            $('#changes-btn-' + productId).remove();
            console.log('acknowledged');
        }
    }


    transferToStockOrder = async (e, orderProductId) => {

        e.preventDefault();

        try {

            const selectedOrderId = localStorage.getItem('selectedStockOrder');

            let quantity = $('#selected-quantity').val();




            if (Utility.isEmpty(selectedOrderId)) {


                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-success order-product-alert">Veillez choisir une cargo commande</div>'
                );
                $('.order-product-alert').delay(2000).fadeOut('slow');

                return;

            }
            const response = await OrderService.convertOrderProductToStockOrder(selectedOrderId, orderProductId, quantity);

            if (response.ok) {

                $('#order-product-row-' + orderProductId).before(
                    '<div class="alert alert-success order-product-alert">Produit Transferé au cargo commande</div>'
                );
                $('.order-product-alert').delay(2000).fadeOut('slow');

                if (Utility.isEmpty(quantity)) {

                    $('#order-product-row-' + orderProductId).delay(3000).remove();
                } else {

                    this.setState({ showTransferModal: false });

                    let exQty = parseInt($('#prod-quantity-' + orderProductId).html());

                    console.log(exQty);
                    let newQty = exQty - parseInt(quantity);

                    $('#prod-quantity-' + orderProductId).html(newQty);

                }




            } else {

                $('#order-product-row-' + orderProductId + ', .error-message').before(
                    '<div class="alert alert-danger order-product-alert">Probleme lors du transfert</div>'
                );
                $('.order-product-alert').delay(3000).fadeOut('slow');
            }



        } catch (error) {

            $('#order-product-row-' + orderProductId).before(
                '<div class="alert alert-danger order-product-alert">Probleme lors du transfert</div>'
            );
            $('.order-product-alert').delay(3000).fadeOut('slow');

        }



    }


    handleCloseTransferModal = () => {

        this.setState({ showTransferModal: false });
    }

    showTransferForm = (e) => {

        e.preventDefault();

        this.setState({ showTransferModal: true });
    }

    pickOrderProduct = async (productId, e) => {
        e.preventDefault();

        try {

            let quantity = $('#picking-quantity-' + productId).val();

            if(Utility.isEmpty(quantity) || this.state.pickingSubmitted){

                return;
            }
           
            const response = await OrderService.pickOrderProductFromWarehouse(productId, quantity);

            if(response.ok){

                const pickingResponse = await response.json();
                

                if(!Utility.isEmpty(pickingResponse)){

                    let currentStock = parseInt($('#stock-quantity-'+productId).html());
                    let newStockQty = currentStock - (quantity);

                    $('#stock-quantity-'+productId).html(newStockQty);

                    $('#picked-quantity-' + productId).html(pickingResponse.quantity);
                }

                $('#order-product-row-' + productId).before(
                    '<div class="alert alert-success order-product-alert">Produit Servi au cargo</div>'
                );
                $('.order-product-alert').delay(3000).fadeOut('slow');

                this.setState({pickingSubmitted: false});
            }else{

                this.setState({pickingSubmitted: false});
                $('#order-product-row-' + productId).before(
                    '<div class="alert alert-danger order-product-alert">Probleme lors du service</div>'
                );
                $('.order-product-alert').delay(3000).fadeOut('slow');
            }

        } catch (error) {

            this.setState({pickingSubmitted: false});

            $('#order-product-row-' + productId).before(
                '<div class="alert alert-danger order-product-alert">Probleme lors du service</div>'
            );
            $('.order-product-alert').delay(3000).fadeOut('slow');
        }


    }



    render() {

        let product = this.props.product;


        const selectedShipment = this.selectedShipment;

        let addToShipmentBtn = '';

        if (!Utility.isEmpty(selectedShipment)) {

            addToShipmentBtn = <button className="btn btn-primary" onClick={() => this.addToShipment(product.id, product.quantity)}>Ajoute au chargement</button>;
        }

        let selectedStatus = '';

        let modifyQuantity = '';

        let remainingQty = '';

        let totalShippedQty = '';

        if (product.shippedQuantity != null) {

            let notLoaded = $('#not-loaded').prop('checked') ? 1 : null;

            console.log('in quantity calcul: '+notLoaded);

            let rqty = product.quantity - product.shippedQuantity;
            remainingQty = 'Restante: ' + rqty;

            totalShippedQty = 'Chargée: ' + product.shippedQuantity;
        }

        //if (product.status == 'New') {

        modifyQuantity = <div className="form-group">
            <label className='float-start'>Commande</label>
            <input className="form-control" placeholder="Quantité" id={"order-product-quantity-" + product.id + ""}
                onBlur={(e) => this.props.updateProductQuantity(e, product.id)} />
        </div>;

        // }

        const selectedOrderId = localStorage.getItem('selectedStockOrder');

        const canTransferToStockOrder =
            (this.props.role == 'MANAGER' || this.props.role == 'SUPER-ADMIN') &&
            this.props.type == 'FACTORY' &&
            !Utility.isEmpty(selectedOrderId);

        const canPickOrderProduct =
            this.props.type == 'FACTORY' &&
            (this.props.role == 'MANAGER' || this.props.role == 'SUPER-ADMIN');

        let numberOfBoxes = product.quantity > 0 && product.quantityInBox > 0 ? product.quantity/product.quantityInBox : 0;
        let weight = product.weight > 0 ? product.weight * numberOfBoxes : 0;
        let cbm = product.cbm > 0 ? product.cbm * numberOfBoxes : 0;



        return (



            <div className="card card-default mt-2" id={"order-product-row-" + product.id}>



                <Modal show={this.state.showModal}>
                    <Modal.Header closeButton onHide={this.handleCloseModal}>Verification</Modal.Header>
                    <Modal.Body>

                        <h2>Voulez vous supprimer?</h2>

                        <span className="error-message"></span>

                        <div className="btn btn-danger full-width mt-2" onClick={(e) => this.props.removeOrderProduct(e, product.id, product.orderId)}>Supprimer</div>


                    </Modal.Body>
                    <Modal.Footer>


                    </Modal.Footer>
                </Modal>


                <Modal show={this.state.showTransferModal}>
                    <Modal.Header closeButton onHide={this.handleCloseTransferModal}>Transfer du Produit au Cargo Commande</Modal.Header>
                    <Modal.Body>


                        <span className="error-message"></span>
                        <div className='form-group'>
                            <input className='form-control' id='selected-quantity' placeholder='Entrez la quantité desirée' />
                        </div>



                        <div className="btn btn-danger full-width mt-2" onClick={(e) => this.transferToStockOrder(e, product.id)}>Transferez</div>


                    </Modal.Body>
                    <Modal.Footer>


                    </Modal.Footer>
                </Modal>

                <ProductImagesModal
                    show={this.state.showGalleryModal}
                    onHide={this.closeProductImages}
                    loading={this.state.galleryLoading}
                    images={this.state.galleryImages}
                    mainImage={this.state.galleryProduct && this.state.galleryProduct.mainImage ? this.state.galleryProduct.mainImage : placeholder}
                    title="Images du produit"
                />


                <div className="card-body" id={'target-'+product.id}>


                    <div className="row" id={"product-row-" + product.id} style={{fontSize:'14px'}}>
                        
                        <div className='col'>
                            
                            <img
                                style={{width: '150px', height: 'auto', cursor: 'pointer'}}
                                src={product.mainImage ? product.mainImage : placeholder}
                                alt="Product"
                                title="Voir toutes les images"
                                onClick={() => this.openProductImages(product)}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = placeholder;
                                }}
                            />

                            <span class="badge bg-warning mt-2">{this.props.rowNumber}</span>
                        </div>
                        <div className="col-md-3">
                            <div>{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                            <div className='fw-bold'>CPID: { product.supplierUniqueId }</div>
                            <div className='fw-bold'>POIDS: { weight }</div>
                            <div className='fw-bold'>CBM: { cbm }</div>
                            <div className='fw-bold'>Qté/Carton: { product.quantityInBox }</div>
                        </div>

                        <div className="col text-start">{product.supplierName}</div>

                        <div className="col" id={"prd-quantity-" + product.id + ""}>


                            <div id={"prod-quantity-" + product.id + ""}>{product.quantity}</div>
                            <div id={"total-shipped-" + product.id + ""}>{totalShippedQty}</div>
                            <div id={"remaining-quantity-" + product.id + ""}> {remainingQty}</div>

                            <div>Qté Cargo: <span id={"stock-quantity-" + product.id + ""}> {product.stockQuantity}</span></div>
                            <div >Qté Servie:  <span id={"picked-quantity-" + product.id + ""}>{product.pickedQuantity}</span></div>

                        </div>





                        <div className="col" id={"prd-price-" + product.id + ""}>{product.price}</div>
                        <div className="col-md-2">

                            {modifyQuantity}
                            <div className="form-group">
                                <label className='label float-start'>Chargement</label>
                                <input className="form-control" placeholder="Quantité" id={"shipment-product-quantity-" + product.id + ""} />
                            </div>

                            <div className="form-group">
                                <input className="form-control" placeholder="Prix" id={"order-product-price-" + product.id}
                                    onBlur={(e) => this.props.priceUpdate(e, product.id)} />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div>{addToShipmentBtn}</div>
                            <div className="form-group mt-2">
                                <label className="label">Statut</label>
                                <select className="form-control" key={product.id} onChange={(e) => this.updateStatus(product.id, e.target.value, e.target.textContent)}>
                                    <option></option>
                                    {this.props.statuses.map(status => {

                                        

                                        return status.id == product.statusId ? <option key={status.id} value={status.id} selected={true}>{status.name}</option> : <option key={status.id} value={status.id}>{status.name}</option>

                                    })}



                                </select>
                            </div>

                            <div className="form-group mt-2">
                                <label className="label">Fournisseur</label>
                                <select className="form-control" onChange={(e) => this.updateSuplier(product.id, e.target.value)}>
                                    <option></option>
                                    {this.props.suppliers.map(supplier =>

                                        product.supplierId == supplier.supplierId ? <option value={supplier.supplierId} selected={true}>{supplier.name}</option> : <option value={supplier.supplierId}>{supplier.name}</option>


                                    )}



                                </select>
                            </div>

                        </div>

                        <div className="col action-column text-end">
                            <Dropdown align="end" autoClose="outside">
                                <Dropdown.Toggle
                                    variant="light"
                                    id={'order-product-actions-' + product.id}
                                    className="border-0 shadow-none px-2 py-1"
                                    aria-label="Actions du produit"
                                    title="Actions"
                                >
                                    <span style={{ fontSize: '24px', lineHeight: 1 }}>⋮</span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu style={{ minWidth: '240px' }}>
                                    {product.changesMade == 1 && (
                                        <Dropdown.Item
                                            as="button"
                                            id={'changes-btn-' + product.id}
                                            onClick={(e) => this.acknowledgeProductChanges(e, product.id)}
                                        >
                                            Reconnaître le changement
                                        </Dropdown.Item>
                                    )}

                                    <Dropdown.Item
                                        as="button"
                                        className="text-danger"
                                        onClick={this.confirmRemoveOrderProduct}
                                    >
                                        Supprimer
                                    </Dropdown.Item>

                                    {canTransferToStockOrder && (
                                        <>
                                            <Dropdown.Divider />
                                            <Dropdown.Header>Transférer au cargo</Dropdown.Header>
                                            <Dropdown.Item
                                                as="button"
                                                className="transfer-btn"
                                                onClick={(e) => this.showTransferForm(e)}
                                            >
                                                Transfert partiel
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                as="button"
                                                className="transfer-btn"
                                                onClick={(e) => this.transferToStockOrder(e, product.id)}
                                            >
                                                Transférer tout
                                            </Dropdown.Item>
                                        </>
                                    )}

                                    {canPickOrderProduct && (
                                        <>
                                            <Dropdown.Divider />
                                            <div className="px-3 pb-2" onClick={(e) => e.stopPropagation()}>
                                                <label
                                                    className="form-label fw-bold mb-1"
                                                    htmlFor={'picking-quantity-' + product.id}
                                                >
                                                    Servir au cargo
                                                </label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    id={'picking-quantity-' + product.id}
                                                    placeholder="Quantité"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.pickOrderProduct(product.id, e);
                                                        }
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm w-100 mt-2"
                                                    onClick={(e) => this.pickOrderProduct(product.id, e)}
                                                >
                                                    Servir
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>


                    </div>
                </div>

            </div>



        )
    }
}

export default OrderProduct;